const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {

  },
  demoNvp: {
    marginBottom: '2em'
  },
  button: {
    ...theme.typography.button,
    textTransform: 'none'
  },
  nvp: {
    ...theme.typography.button,
    textTransform: 'none',
    padding: '1rem 0rem',
    position: 'relative',
    top: '3em',
  },
  singlePair: {
    ...theme.typography.button,
    textTransform: 'none',
    marginTop: '4em'
  },
  twoPair: {
    ...theme.typography.button,
    textTransform: 'none',
    marginBottom: '1.5em',
    marginTop: '5em'
  },
  limitNVP: {
    ...theme.typography.button,
    textTransform: 'none',
    marginBottom: '5em',
    marginTop: '8em'
  },
  title: {
    fontSize: '3em'
  },
  cardContent: {
    padding: '0px !important'
  },
  cardActions: {
    padding: '4px 4px',
    height: 'auto'
  },
  cardActionsTitle: {
    background: '#005795 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtestpassed: {
    background: '#43A547 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtestfailed: {
    background: '#ff5252 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtesttitle: {
    color: '#FFFFFF'
  },
  cardActionsNav: {
    background: '#FF643B !important',
    padding: '5px',
    textAlign: 'center'
  },
  nav: {
    padding: 'initial',
    minWidth: 'initial',
    minHeight: 'initial'
  },
  borderpassed: {
    border: '2px solid #43A547'
  },
  borderfailed: {
    border: '2px solid #ff5252'
  },
  hyphen: {
    fontSize: '2em',
    margin: '0px 2px'
  },
  impedancePair: {
    display: 'block'
  },
  impedancePairTitle: {
    display: 'inline',
    marginRight: '10px',
    fontWeight: 'bold'
  },
  impedancePairValue: {
    display: 'inline',
  },
})

export default styles
